var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a-space',{attrs:{"align":"center"}},[_c('a-icon',{style:({ 'font-size': '.9rem' }),attrs:{"component":_vm.TrawlPackIcon}}),_vm._v(" "),_c('span',{style:({ 'font-size': '0.65rem' })},[_vm._v("TRAWL "),_c('b',[_vm._v("PACK")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }